<!-- eslint-disable vue/no-parsing-error -->
<template>
    <v-list nav dense>
        
        <v-list-item-group>
        <!--<v-list-group >
            <template v-slot:activator>
                <v-list-item-icon>
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title> Mi organización </v-list-item-title>
                </v-list-item-content>
            </template>-->

            <!-- Persona -->
            <router-link
                class="menu-item"
                to="Persona"
                active-class="active-link"

                v-if="persona.Rol==1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-account-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Persona")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
        
            <!-- Unidad Académica -->
            <!--<router-link
                class="menu-item"
                to="UnidadAcademica"
                active-class="active-link"

                v-if="persona.Rol<3"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-school</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.UnidadAcademica")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>-->

            <!-- Rol -->
            <!--<router-link
                class="menu-item"
                to="Rol"
                active-class="active-link"

                v-if="persona.Rol<3"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-key</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Rol")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>-->

            <!-- <router-link
                class="menu-item"
                to="EditUnidadAcademica"
                active-class="active-link"

                v-if="persona.Rol!=3"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-sticker-emoji</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title> Registro </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <!-- Perfil -->
            <!--<router-link
                class="menu-item"
                to="Profile"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-account-circle</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Profile")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

        </v-list-group>-->

        <v-list-group >
            <template v-slot:activator>
                <v-list-item class="menu-item">
                    <v-list-item-icon>
              <v-icon>mdi-book</v-icon>
             </v-list-item-icon>
               
                <v-list-item-content>
                    <v-list-item-title> Libros </v-list-item-title>
                </v-list-item-content>
         </v-list-item>

            </template>

             <!-- Libro -->
            <router-link
                class="menu-item"
                to="Libro"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-book-open</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Libro")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Tipo de Libro -->
            <router-link
                class="menu-item"
                to="TipoLibro"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-book-open-variant</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.TipoLibro")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Categoría -->
            <router-link
                class="menu-item"
                to="Categoria"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-bookmark-outline</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Categoria")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Origen -->
            <router-link
                class="menu-item"
                to="Origen"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-crosshairs</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Origen")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Editorial -->
            <router-link
                class="menu-item"
                to="Editorial"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-book-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Editorial")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Autor -->
            <router-link
                class="menu-item"
                to="Autor"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Autor")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- Estado -->
            <router-link
                class="menu-item"
                to="Estado"
                active-class="active-link"

                v-if="persona.Rol<3"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-checkerboard</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Estado")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
            
            <!-- <router-link
                class="menu-item"
                to="PortadaLibro"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-account-circle</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.PortadaLibro")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <!-- Reparticion -->
            <router-link
                class="menu-item"
                to="Reparticion"
                active-class="active-link"

                v-if="persona.Rol<3"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-border-inside</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Reparticion")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <!-- LibroAutor -->
            <router-link
                class="menu-item"
                to="LibroAutor"
                active-class="active-link"

                v-if="persona.Rol<4"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-file-account</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.LibroAutor")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
            
            <!-- Clase -->
            <router-link
                class="menu-item"
                to="Clase"
                active-class="active-link"

                v-if="persona.Rol==1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-dns</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Clase")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="NivelAcademico"
                active-class="active-link"

                v-if="persona.Rol==1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-dns</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.NivelAcademico")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

            <router-link
                class="menu-item"
                to="Especialidad"
                active-class="active-link"

                v-if="persona.Rol==1"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-dns</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Especialidad")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>


        </v-list-group>

       <!--  <v-list-group>
            <template v-slot:activator>
                <v-list-item-icon>
                    <v-icon>mdi-cog</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title> Reserva de Libros </v-list-item-title>
                </v-list-item-content>
            </template>
            <router-link
                class="menu-item"
                to="Reserva"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-calendar-multiple-check</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Reserva")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
        </v-list-group>
 -->

        <v-list-group>
            <template v-slot:activator>
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                      <v-icon>mdi-dns</v-icon>
                         </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title> Otros recursos </v-list-item-title>
                </v-list-item-content>
         </v-list-item>

            </template>
            <router-link
                class="menu-item"
                to="BibliotecaVirtual"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon>mdi-airplay</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.BibliotecaVirtual")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>

          <!-- <router-link
            class="menu-item"
            to="RepoGrado"
            active-class="active-link"
            v-if="persona.Rol<6"
            >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon> mdi-checkbox-multiple-blank-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        $t("nav.RepoGrado")
                        }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </router-link>

        <router-link
            class="menu-item"
            to="RepoPosgrado"
            active-class="active-link"
            v-if="persona.Rol<6"
            >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon> mdi-checkbox-multiple-blank </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        $t("nav.RepoPosgrado")
                        }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </router-link> -->


           <!--  <router-link
                class="menu-item"
                to="TrabajosGrado"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-note-multiple-outline</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.TrabajosGrado")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <!-- <router-link
                class="menu-item"
                to="TrabajosPosgrado"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-note-multiple</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.TrabajosPosgrado")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
 -->
            <!-- <router-link
                class="menu-item"
                to="Investigaciones"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-book-open</v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.Investigaciones")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link> -->

            <router-link
                class="menu-item"
                to="DiccionarioMilitar"
                active-class="active-link"

                v-if="persona.Rol<6"
            >
                <v-list-item class="menu-item">
                    <v-list-item-icon>
                        <v-icon> mdi-wan </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content>
                        <v-list-item-title>{{
                            $t("nav.DiccionarioMilitar")
                        }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </router-link>
        </v-list-group>

        <router-link
            class="menu-item"
            to="Usuarios"
            active-class="active-link"
            v-if="persona.Rol<4"
            >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon> mdi-account-multiple </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        $t("nav.Usuarios")
                        }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </router-link>

        <router-link
            class="menu-item"
            to="Reserva"
            active-class="active-link"
            v-if="persona.Rol<6"
        >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon>mdi-calendar-multiple-check</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        Reservas 
                    </v-list-item-title>
                </v-list-item-content>
                </v-list-item>
        </router-link>

        <router-link
            class="menu-item"
            to="Reporte"
            active-class="active-link"
            v-if="persona.Rol<4"
        >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon>mdi-page-layout-sidebar-right</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        Reportes
                    </v-list-item-title>
                </v-list-item-content>
                </v-list-item>
        </router-link>

        <router-link
            class="menu-item"
            to="Estadisticas"
            active-class="active-link"
            v-if="persona.Rol<4"
        >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon>mdi-chart-areaspline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>
                        Estadísticas
                    </v-list-item-title>
                </v-list-item-content>
                </v-list-item>
        </router-link>

        <!--<router-link
            class= "menu-item"
            to="Buscador"
            active-class="active-link"
            v-if="persona.Rol<6"
            >
            <v-list-item class="menu-item">
                <v-list-item-icon>
                    <v-icon> mdi-home-variant </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                    <v-list-item-title>{{
                        $t("nav.Buscador")
                        }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </router-link>-->
        </v-list-item-group>

    </v-list>
</template>

<script>
export default {
    name: "MenuVuetify",
    data() {
        return {
            msg: "MenuVuetify",
            persona: {}
        };
    },

    mounted() {
        this.persona = JSON.parse(localStorage.getItem('persona'));
    } 
};
</script>
